import React from 'react';
import ReactDOM from 'react-dom';
import { NiceMessageDialog, NiceMessageDialogProps } from '.';
import { Button } from 'antd';
import { tolgee } from 'services/i18n/tolgee';
import { appShortcutDialogCache, appShortcutDialogDisableCache } from 'services/cache';
import { isNumber } from 'lodash-es';
import { getAppProductName } from 'hooks/useTrans';

export const showRequestNotificationDialog = () => {
  const container = document.createDocumentFragment();

  const close = () => {
    render(false);
  };

  let config: NiceMessageDialogProps = {
    visible: true,
    title: tolgee.t('消息通知权限'),
    content: tolgee.t('消息通知权限内容'),
    footer: (
      <Button className="mt-4" type="primary" onClick={close}>
        {tolgee.t('好的我知道了')}
      </Button>
    ),
    onCancel: () => {
      ReactDOM.unmountComponentAtNode(container);
    },
  };

  const render = (visible: boolean) => {
    ReactDOM.render(React.createElement(NiceMessageDialog, { ...config, visible }), container);
  };

  render(true);
};

let renderFlag = false;
const showInstallPrompt = () => {
  if (renderFlag) return;
  const container = document.createDocumentFragment();

  const close = () => {
    renderFlag = false;
    appShortcutDialogDisableCache.set('1');
    render(false);
  };

  let config: NiceMessageDialogProps = {
    visible: true,
    title: tolgee.t('添加桌面快捷方式'),
    content: tolgee.t('添加桌面快捷方式内容', {
      appProductName: getAppProductName(),
    }),
    footer: (
      <>
        <Button
          key="enable"
          className="mt-4"
          type="primary"
          onClick={async () => {
            close();
            if (!window.__appDeferredPrompt) return;
            // deferredPrompt is a global variable we've been using in the sample to capture the `beforeinstallevent`
            window.__appDeferredPrompt.prompt();
            // Find out whether the user confirmed the installation or not
            const { outcome } = await window.__appDeferredPrompt.userChoice;
            // The deferredPrompt can only be used once.
            window.__appDeferredPrompt = null;
            // Act on the user's choice
            if (outcome === 'accepted') {
              console.log('User accepted the install prompt.');
            } else if (outcome === 'dismissed') {
              console.log('User dismissed the install prompt');
            }
          }}
        >
          {tolgee.t('立即添加')}
        </Button>
        <Button key="disable" className="mt-2" type="text" onClick={close}>
          {tolgee.t('暂不添加')}
        </Button>
      </>
    ),
    onCancel: () => {
      ReactDOM.unmountComponentAtNode(container);
    },
  };

  const render = (visible: boolean) => {
    renderFlag = true;
    ReactDOM.render(React.createElement(NiceMessageDialog, { ...config, visible }), container);
  };

  render(true);
};

const VISIT_COUNT = 10;
export const showAddAppShortcutDialog = () => {
  if (appShortcutDialogDisableCache.get() === '1' || !window.__appDeferredPrompt) return;

  const value = appShortcutDialogCache.get<number>();

  if (value && isNumber(value)) {
    appShortcutDialogCache.set(value + 1);
  } else {
    appShortcutDialogCache.set(1);
  }

  if (value && value >= VISIT_COUNT) {
    showInstallPrompt();
  }
};

export const isAddAppShortcutDialogEnable = () => {
  const cache = appShortcutDialogDisableCache.get();
  const cont = appShortcutDialogCache.get<number>();
  return cache !== '1' || (cont && cont < VISIT_COUNT);
};
